import { createRoutine } from 'redux-saga-routines';

export const fetchGroupedAssignments = createRoutine(
  'assessment/FETCH_GROUPED_ASSIGNMENTS',
);

export const ASSIGNMENT_GROUP_CHANGED =
  'assessment/assignItem/ASSIGNMENT_GROUP_CHANGED';

export const setAssessmentGroup = (assessmentGroup) => {
  const state = {
    type: ASSIGNMENT_GROUP_CHANGED,
    assessmentGroup,
  };

  if (assessmentGroup) {
    // Due to the complications associated with "unit" members, we don't default the
    // `assignableGroupMembers` property of the state to the value if there are units.
    // If we don't we run the risk of the system accidentally assigning every possible
    // member to the user which is generally bad. So, if we find a unit, then we just
    // don't set the assignableGroupMembers. It's up to the `setAssignableGroupMembers`
    // dispatch to actually set this value.
    let hasUnits = false;
    for (let i = 0; i < assessmentGroup.members.length; i++) {
      if (assessmentGroup.members[i].partType === 'unit') {
        hasUnits = true;
        break;
      }
    }

    if (!hasUnits) {
      state.assignableGroupMembers = assessmentGroup.members;
    }
  } else {
    // if this is clearing the assessmentGroup, also clear the assignableGroupMembers.
    state.assignableGroupMembers = null;
  }

  return state;
};
